import React, { useMemo } from 'react';
import {
  listItemSectionBuilder,
  Search,
  SearchProps,
} from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';

interface BannerSearchProps
  extends Omit<SearchProps, 'placeholder' | 'options' | 'predicate'> {}

const suggestionKeySuffixes = [
  'business-site',
  'landing-page',
  'blog',
  'portfolio',
  'ecommerce',
];
const getSuggestionKey = (suggestionKeySuffix: string) => {
  return `marketplace.templates-page.template-search.suggestion-${suggestionKeySuffix}`;
};

export const TemplateSearchField = ({
  value,
  onEnterPressed: _onEnterPressed,
  onSelect: _onSelect,
  ...props
}: BannerSearchProps) => {
  const { t } = useTranslation();
  const { templateSearchFieldRef } = useTemplatesContext();

  const options = useMemo(() => {
    const suggestions = suggestionKeySuffixes.map((suggestion, index) => {
      return { id: index + 1, value: t(getSuggestionKey(suggestion)) };
    });
    const sectionOptions = [
      listItemSectionBuilder({
        id: 0,
        type: 'title',
        title: t(getSuggestionKey('header')),
      }),
      ...suggestions,
    ];

    return sectionOptions;
  }, [t]);

  const onEnterPressed: SearchProps['onEnterPressed'] = (e) => {
    _onEnterPressed?.(e);
    templateSearchFieldRef?.current?.blur();
  };

  const onSelect: SearchProps['onSelect'] = (option, sameOptionWasPicked) => {
    _onSelect?.(option, sameOptionWasPicked);
    templateSearchFieldRef?.current?.blur();
  };

  return (
    <Search
      ref={templateSearchFieldRef}
      // if you have a value, search won't collapse
      maxLength={100}
      value={value}
      placeholder={t('marketplace.templates-page.template-search.placeholder')}
      options={options}
      predicate={() => false}
      onEnterPressed={onEnterPressed}
      onSelect={onSelect}
      popoverProps={{ zIndex: 5 }}
      {...props}
    />
  );
};

export default TemplateSearchField;
